const MAX_TOTAL_DISMISSALS = 4;
const FOURTEEN_DAYS_MS = 14 * 24 * 60 * 60 * 1000;
const DEFER_COUNT = 3;

export {
    MAX_TOTAL_DISMISSALS, FOURTEEN_DAYS_MS, DEFER_COUNT
};
